import { message } from "antd";
import { Conf } from "..";
import { formatDate } from "./formatTime";

//ip转换
export const strtoip = function (proper_address: number) {
	proper_address = proper_address >>> 0;
	let output = '';  // www.
	if (!isNaN(proper_address) && (proper_address >= 0 || proper_address <= 4294967295)) {
		output = Math.floor(proper_address / Math.pow(256, 3)) + '.' +
			Math.floor((proper_address % Math.pow(256, 3)) / Math.pow(256, 2)) + '.' +
			Math.floor(((proper_address % Math.pow(256, 3)) % Math.pow(256, 2)) /
				Math.pow(256, 1)) + '.' +
			Math.floor((((proper_address % Math.pow(256, 3)) % Math.pow(256, 2)) %
				Math.pow(256, 1)) / Math.pow(256, 0));
	}
	return output;
};
/**
 * 
 * @param img 图片地址补全
 * @returns 
 */
export const imgUrl = function (img: string) {
	let reg = /([http|https]*?:\/\/)/;
	let url = "";
	if (reg.test(img)) {
		url = img;
	} else {
		url = Conf.sys.file_url + img
	}
	return url;
}

export const success = function (msg: string) {
	message.destroy();
	message.success(msg);
}
export const error = function (msg: string) {
	message.destroy();
	message.error(msg);
}

/**
 * 时间日期转换
 * @param date 当前时间，new Date() 格式
 * @param format 需要转换的时间格式字符串
 * @description format 字符串随意，如 `YYYY-mm、YYYY-mm-dd`
 * @description format 季度："YYYY-mm-dd HH:MM:SS QQQQ"
 * @description format 星期："YYYY-mm-dd HH:MM:SS WWW"
 * @description format 几周："YYYY-mm-dd HH:MM:SS ZZZ"
 * @description format 季度 + 星期 + 几周："YYYY-mm-dd HH:MM:SS WWW QQQQ ZZZ"
 * @returns 返回拼接后的时间字符串
 */
export const numToTime = (num: number, format: string) => {
	const date = num > 0 ? (new Date(num * 1000)) : (new Date());
	return formatDate(date, format)
}

export const get_first_image = (str: string) => {
	var data = '';
	str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, function (_, capture): any {
		console.log(capture)
		data = capture;
	});
	return data
}

export const filterHTMLTag = (str: string) => {
	str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
	str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
	// str=str.replace(/ /ig,'');//去掉
	return str;
}